import { baseItemCSS } from './base-item';
export const linkItemCSS = (isDisabled, isSelected) => ({ ...baseItemCSS(isDisabled, isSelected)
});